import React from 'react'
// import { useCustomLogoQuery } from '../../hooks/useCustomLogoQuery'


import logoBetong from '../../images/logo-betong-negativ.png'
import logoArkitektur from '../../images/logo-arkitekt-negativ.png'
import logoDefault from '../../images/logo-byggframtid-negativ.png'

/**
 * Logo component that selects the appropriate logo based on the `logoSrc` prop.
 *
 * @param {Object} props
 * @param {string} props.src - The logo source type (betong, arkitektur, default).
 * @param {string} [props.height] - The height of the logo (optional).
 * @returns {JSX.Element} - The logo image element.
 */
const Logo = ({ src, height = 'auto' }) => {
  const logoImage = 
    src === 'betong' ? logoBetong :
    src === 'arkitektur' ? logoArkitektur :
    logoDefault

  return <img src={logoImage} alt="Logo" height={height} />
}

export default Logo
